import { useMemo } from 'react'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Loader } from '@/modules/shared/components/loader/Loader'
import { SlotCard } from './SlotCard'

import type { SlotWithLocationAndDoctor } from '../types/booking.type'

type SlotListProps = {
  slots: SlotWithLocationAndDoctor[]
  onSlotSelect: (
    action: 'select-slot',
    data?: {
      slot: SlotWithLocationAndDoctor
    },
  ) => void
  isLoading: boolean
  isStale?: boolean
}

export const SlotList = ({ slots: slotsProp, onSlotSelect, isLoading, isStale = false }: SlotListProps) => {
  const theme = useTheme()

  const slots = useMemo(() => {
    return slotsProp.sort((a, b) => {
      const timeA = new Date(a.start).getTime()
      const timeB = new Date(b.start).getTime()
      const timeComparison = timeA - timeB
      if (timeComparison !== 0) {
        return timeComparison
      }

      // If start times are the same, maintain current order
      return 0
    })
  }, [slotsProp])

  if (isLoading || isStale) {
    return <Loader small style={{ height: 'auto', paddingBlock: '24px' }} />
  }

  return (
    <FlexColumn gap={theme.UI.SpacingPx.Space2}>
      {slots.map((slot) => (
        <SlotCard
          key={`slot-${slot.agendaId}-${slot.start}`}
          slot={slot}
          onSlotSelect={onSlotSelect}
          isLoading={isLoading}
        />
      ))}
    </FlexColumn>
  )
}
